// extracted by mini-css-extract-plugin
export default {"Container":"BackgroundVideo_Container__dn53t","Video":"BackgroundVideo_Video__-kfHp","Content":"BackgroundVideo_Content__Rynq5","SubContent":"BackgroundVideo_SubContent__hzVAX"};